import {
  ValidateAgenticLogicTemplateRequestBodyType,
  ValidateAgenticLogicTemplateRequestPathParamsType,
  ValidateAgenticLogicTemplateResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const validateAgenticLogicTemplate = async (
  payload: ApiRequest<
    ValidateAgenticLogicTemplateRequestBodyType,
    ValidateAgenticLogicTemplateRequestPathParamsType
  >
) => {
  const response = await api.post<
    ValidateAgenticLogicTemplateResponseBodyType,
    ValidateAgenticLogicTemplateRequestBodyType
  >(
    `/v2/agentic-logic/templates/${encodeURIComponent(payload.pathParams.templateId)}/validate`,
    payload.body
  );
  return response.data;
};

export const useValidateAgenticLogicTemplate = () =>
  useMutation<
    ValidateAgenticLogicTemplateResponseBodyType,
    Error,
    ApiRequest<
      ValidateAgenticLogicTemplateRequestBodyType,
      ValidateAgenticLogicTemplateRequestPathParamsType
    >,
    unknown
  >({ mutationFn: validateAgenticLogicTemplate });
